"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react2 = require("@emotion/react");

var _theme = require("../../theme/theme");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FlexUnit = function FlexUnit(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? "div" : _ref$as,
      _ref$fluid = _ref.fluid,
      fluid = _ref$fluid === void 0 ? false : _ref$fluid,
      _ref$stretch = _ref.stretch,
      stretch = _ref$stretch === void 0 ? false : _ref$stretch,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? "center" : _ref$align,
      _ref$justify = _ref.justify,
      justify = _ref$justify === void 0 ? "center" : _ref$justify,
      _ref$grow = _ref.grow,
      grow = _ref$grow === void 0 ? 1 : _ref$grow,
      _ref$shrink = _ref.shrink,
      shrink = _ref$shrink === void 0 ? 1 : _ref$shrink,
      _ref$basis = _ref.basis,
      basis = _ref$basis === void 0 ? "auto" : _ref$basis,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? "0" : _ref$mt,
      _ref$mb = _ref.mb,
      mb = _ref$mb === void 0 ? "0" : _ref$mb,
      _ref$ml = _ref.ml,
      ml = _ref$ml === void 0 ? "0" : _ref$ml,
      _ref$mr = _ref.mr,
      mr = _ref$mr === void 0 ? "0" : _ref$mr;

  var spaceT = _theme.MAP_SPACE[String(mt)];

  var spaceB = _theme.MAP_SPACE[String(mb)];

  var spaceL = _theme.MAP_SPACE[String(ml)];

  var spaceR = _theme.MAP_SPACE[String(mr)];

  return (0, _react2.jsx)(_react2.ClassNames, null, function (_ref2) {
    var css = _ref2.css,
        cx = _ref2.cx;
    return /*#__PURE__*/_react["default"].createElement(as, {
      className: cx(className, css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                box-sizing: border-box;\n                align-self: ", ";\n                justify-self: ", ";\n                flex-grow: ", ";\n                flex-shrink: ", ";\n                flex-basis: ", ";\n                width: ", ";\n                height: ", ";\n                margin-top: ", ";\n                margin-bottom: ", ";\n                margin-left: ", ";\n                margin-right: ", ";\n              "])), align, justify, grow, shrink, basis, fluid ? '100%' : 'auto', stretch ? '100%' : 'auto', spaceT, spaceB, spaceL, spaceR))
    }, children);
  });
};

FlexUnit.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  as: _propTypes["default"].string,
  fluid: _propTypes["default"].bool,
  stretch: _propTypes["default"].bool,
  align: _propTypes["default"].oneOf(_theme.FLEX_ALIGNSELF_TYPES),
  justify: _propTypes["default"].oneOf(_theme.FLEX_JUSTIFY_TYPES),
  grow: _propTypes["default"].oneOf(_theme.FLEX_SIZE_TYPES),
  shrink: _propTypes["default"].oneOf(_theme.FLEX_SIZE_TYPES),
  basis: _propTypes["default"].string,
  mt: _propTypes["default"].oneOf(_theme.SPACE_TYPES),
  mb: _propTypes["default"].oneOf(_theme.SPACE_TYPES),
  ml: _propTypes["default"].oneOf(_theme.SPACE_TYPES),
  mr: _propTypes["default"].oneOf(_theme.SPACE_TYPES)
};
var _default = FlexUnit;
exports["default"] = _default;